import React from 'react';
import styled from 'styled-components';

export const Heading = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;

  .product-name {
    font-size: 16px;
    font-weight: 500;
    color: #555658;
  }

  .product-description {
    font-size: 14px;
    font-weight: 500;
    color: #898b8e;
  }
`;

type HeadProductProps = {
  productIcon: React.ReactNode;
  name: string;
  description: string;
};

export const HeadProduct: React.FC<HeadProductProps> = ({ productIcon, description, name }) => {
  return (
    <Heading>
      <div className="icon-wrapper">{productIcon}</div>
      <div>
        <p className="product-name">{name}</p>
        <p className="product-description">{description}</p>
      </div>
    </Heading>
  );
};
